<template src="./index.html" />
<script>
import {
  mapState, mapActions, mapMutations,
} from 'vuex';
import ChangeEmailModal from '@/components/ChangeEmailModal';
import EmptyListing from '../emptyListing/index.vue';
import API from '@/services/GraphQl';
import AppAccessModal from '@/components/App/AppAccessModal';
/* eslint-disable vue/require-prop-types */
export default {
  name: 'TableProject',
  components: {
    EmptyListing,
    ChangeEmailModal,
    AppAccessModal,
  },
  props: ['headers'],
  data: () => ({
    searchString: '',
    options: {
      itemsPerPage: 50,
      mustSort: true,
      page: 1,
      sortBy: ['name'],
      sortDesc: [false],
    },
    userAttributes: {
    },
    footerOptions: {
      itemsPerPageOptions: [50, 100, 200],
      showCurrentPage: true,
      showFirstLastPage: true,
    },
  }),
  computed: {
    ...mapState(['users', 'showSpinner', 'isLoadedUsersList']),
    getUsers() {
      return this.users;
    },
  },
  watch: {
    searchString() {
      // Reset to page 1 whenever search changes
      this.options.page = 1;
    },
  },
  created() {
    // Automatically load all users when component is created
    if (!this.users.length) {
      this.getAllUsers({
        ascending: false,
      });
    }
  },
  methods: {
    ...mapActions(['getAllUsers', 'handleError']),
    ...mapMutations(['changeUserList', 'spinner', 'openSnackBar']),
    customFilter(_, search, item) {
      const name = item.name || '';
      const email = item.email || '';
      const company = item.company || '';
      return name.toLowerCase().includes(search.toLowerCase()) ||
             email.toLowerCase().includes(search.toLowerCase()) ||
             company.toLowerCase().includes(search.toLowerCase());
    },
    async fetchUserAttributes(userEmail) {
      try {
        this.spinner(true);
        const { data } = await API.fetchUserAttributes({
          userEmail,
        });
        this.userAttributes = data.response;
      } catch (e) {
        this.handleError(e);
        return null;
      } finally {
        this.$refs.appAccessModal.showModal();
        this.spinner(false);
      }
    },
    openChangeEmailModal(id, email) {
      this.$refs.changeEmailModal.showModal(id, email);
    },
    async sendTemporaryPasswords(userId) {
      try {
        this.spinner(true);
        await API.sendTemporaryPassword({
          userId,
        });
        this.openSnackBar({
          text: 'Temporary password was successfully sent to user',
        });
      } catch (e) {
        this.handleError(e);
      } finally {
        this.spinner(false);
      }
    },
    async toggleAppAccess(userEmail, access) {
      try {
        this.spinner(true);
        const { data } = await API.toggleAppAccess({
          userEmail,
          access,
        });
        const response = data.toggleAppAccess;
        const text = response
          ? `App access ${access === 'true' ? 'enabled' : 'disabled'} successfully`
          : `Some Error Occurred`;
        this.openSnackBar({
          text,
        });
        this.userAttributes = {
        };
      } catch (e) {
        this.handleError(e);
        return false;
      } finally {
        this.spinner(false);
      }
    },
    updateUserEmail(currentUser) {
      const updateUser = this.users.map(e => e.id === currentUser.id ? {
        ...e, ...currentUser,
      } : e);
      this.changeUserList(updateUser);
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
